exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__3Ihlt{display:none !important}}@media (min-width: 768px){.styles--smUp__3eXIm{display:none !important}}@media (max-width: 999px){.styles--mdDown__KkRVt{display:none !important}}.styles--viewerBlock__panelAttach__3pOuC{margin-left:20px}.styles--viewerBlock__panelAttach__3pOuC .button{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0;padding-right:20px;padding-left:16px}.styles--viewerBlock__panelAttach__3pOuC .button .svgicon{margin-right:3px}.styles--controls__20cMn>*{cursor:pointer}.styles--controls__20cMn>*:not(:first-child){padding-left:16px}.styles--controls__20cMn>*:not(:last-child){padding-right:16px}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__3Ihlt",
	"smUp": "styles--smUp__3eXIm",
	"mdDown": "styles--mdDown__KkRVt",
	"viewerBlock__panelAttach": "styles--viewerBlock__panelAttach__3pOuC",
	"viewerBlockPanelAttach": "styles--viewerBlock__panelAttach__3pOuC",
	"controls": "styles--controls__20cMn"
};